/**
 * @generated SignedSource<<3ef5b374b53be087fbf1c5d80016200d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JobApplicationStatus = "deleted" | "freelancer_not_interested" | "hired" | "interview" | "job_application_draft" | "job_application_invited" | "job_application_sent" | "job_viewed" | "offer" | "potential" | "rejected" | "screening_completed" | "screening_rejected" | "screening_requested" | "screening_started";
import { FragmentRefs } from "relay-runtime";
export type JobHeader_JobApplication$data = {
  readonly status: JobApplicationStatus;
  readonly " $fragmentType": "JobHeader_JobApplication";
};
export type JobHeader_JobApplication$key = {
  readonly " $data"?: JobHeader_JobApplication$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobHeader_JobApplication">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobHeader_JobApplication",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "JobApplication",
  "abstractKey": null
};

(node as any).hash = "5952b2d33d5a1a7bf6bebf2ad2262fec";

export default node;
